module.exports = __webpack_public_path__ + "img/IMG_8976.214a3065.jpg";